(function () {
  function activateFaq(root, item) {
    if (!item || item.classList.contains('is-active')) return;

    var index = item.getAttribute('data-index');
    var items = root.querySelectorAll('[data-faq-item]');
    var mediaItems = root.querySelectorAll('[data-faq-media]');

    items.forEach(function (faqItem) {
      var isActive = faqItem === item;
      faqItem.classList.toggle('is-active', isActive);

      var trigger = faqItem.querySelector('[data-faq-trigger]');
      var panel = faqItem.querySelector('[data-faq-panel]');

      if (trigger) {
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }

      if (panel) {
        panel.hidden = !isActive;
      }
    });

    mediaItems.forEach(function (mediaItem) {
      mediaItem.classList.toggle(
        'is-active',
        mediaItem.getAttribute('data-index') === index
      );
    });
  }

  function initFaq(root) {
    if (!root || root.dataset.faqInitialized === 'true') return;
    root.dataset.faqInitialized = 'true';

    root.querySelectorAll('[data-faq-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-faq-item]');
        if (item) activateFaq(root, item);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-oeh-stu-faq-root]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-faq-root]');
    if (root) {
      delete root.dataset.faqInitialized;
      initFaq(root);
    }
  });
})();
